export const localStorageKeysObject: LocalStorageKeysObject = {
  passwordNotSetNoticeModal: {
    key: 'PasswordNotSetNoticeModal',
    default: {
      rejectedOnThisDevice: false,
    },
  },
  shoppingOnboardingModal: {
    key: 'onboarding',
    default: {
      shoppingSeen: false,
    },
  },
  mobilePremiumAccountDashboard: {
    key: 'MobileDashboard',
    default: {
      type: 'payments',
    },
  },
}

export type LocalStorageKeysObject = {
  passwordNotSetNoticeModal: {
    key: 'PasswordNotSetNoticeModal'
    default: {
      rejectedOnThisDevice: boolean
    }
  }
  shoppingOnboardingModal: {
    key: 'onboarding'
    default: {
      shoppingSeen: boolean
    }
  }
  mobilePremiumAccountDashboard: {
    key: 'MobileDashboard'
    default: {
      type: 'payments' | 'installments'
    }
  }
}
